<template>
  <!-- Search -->
  <form>
    <input type="text" class="form-control" placeholder="Search here" />
    <button class="btn" type="submit">
      <img src="@/assets/img/icons/search.svg" alt="img" />
    </button>
  </form>
</template>
